/* Versana Necklace builder: 2 to 8 pendants on the side of a cable chain, each an initial or a birthstone.
   The live preview is its own slide in the product photo gallery (same as Sora); the picker follows the Fable flow.
   The pendant count is a dropdown with prices (like Eliora) that drives the theme's hidden variant buttons.
   Pendants read top to bottom in the customer's order. Up to 5 pendants use the close-up chain photo,
   6 to 8 use the zoomed-out one. Every pendant/position pair is pre-rendered (linked into the chain),
   so the page only stacks the right tiles on the chain photo.
   Line-item properties are sent with exactly the names and values the previous personalizer used.
   The Versana Bracelet uses this same builder with the preview turned off ("preview": false in the snippet), since
   the preview photos show the necklace; the bracelet keeps its own photos. */
(function () {
  'use strict';
  var root = document.querySelector('[data-versana]');
  if (!root || root.__vsn) return;
  root.__vsn = true;
  var CFG = JSON.parse(root.getAttribute('data-cfg'));
  var PREVIEW = CFG.preview !== false, ITEM = CFG.item || 'necklace';
  var GEO = {"close":{"slots":[{"x":148,"y":80,"w":112,"h":216,"st":[196.92,192.22,14.96]},{"x":180,"y":286,"w":111,"h":192,"st":[232.45,384.72,14.96]},{"x":220,"y":467,"w":109,"h":194,"st":[272.32,576.46,14.96]},{"x":268,"y":649,"w":104,"h":189,"st":[314.83,741.22,14.96]},{"x":326,"y":822,"w":160,"h":199,"st":[386.09,913.37,14.96]}]},"far":{"slots":[{"x":142,"y":68,"w":80,"h":147,"st":[177.99,164.79,10.45]},{"x":157,"y":207,"w":81,"h":110,"st":[194.15,262.47,10.45]},{"x":175,"y":308,"w":79,"h":110,"st":[211.32,361.29,10.45]},{"x":195,"y":410,"w":78,"h":106,"st":[230.15,461.74,10.45]},{"x":214,"y":506,"w":78,"h":107,"st":[249.76,556.89,10.45]},{"x":238,"y":603,"w":76,"h":108,"st":[272.85,655.93,10.45]},{"x":269,"y":700,"w":72,"h":106,"st":[300.89,755.07,10.45]},{"x":300,"y":793,"w":90,"h":141,"st":[334.09,845.73,10.45]}]}};

  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  /* [month, stone, value exactly as it has always been sent to orders] */
  var STONES = [
    ['January', 'Garnet', 'January - Garnet'],
    ['February', 'Amethyst', 'February - Amethyst '],
    ['March', 'Aquamarine', 'March - Aquamarine'],
    ['April', 'Diamond', 'April - Diamond'],
    ['May', 'Emerald', 'May - Emerald'],
    ['June', 'Alexandrite', 'June - Alexandrite'],
    ['July', 'Ruby', 'July - Ruby'],
    ['August', 'Peridot', 'August - Peridot '],
    ['September', 'Sapphire', 'September - Sapphire'],
    ['October', 'Pink Tourmaline', 'October - Pink Tourmaline'],
    ['November', 'Topaz', 'November - Topaz'],
    ['December', 'Zircon', 'December - Zircon']
  ];
  var ORDS = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth'];
  var MAX = 8;
  /* which spot each pendant takes, top to bottom, for every pendant count (spots are numbered top to bottom) */
  var LAYOUT = {
    1: { view: 'close', slots: [2] },
    2: { view: 'close', slots: [2, 3] },
    3: { view: 'close', slots: [1, 2, 3] },
    4: { view: 'close', slots: [0, 1, 2, 3] },
    5: { view: 'close', slots: [0, 1, 2, 3, 4] },
    6: { view: 'far', slots: [2, 3, 4, 5, 6, 7] },
    7: { view: 'far', slots: [1, 2, 3, 4, 5, 6, 7] },
    8: { view: 'far', slots: [0, 1, 2, 3, 4, 5, 6, 7] }
  };
  var ANS = [
    { cat: 'initial', name: 'Initial', sub: 'A letter, A to Z' },
    { cat: 'birthstone', name: 'Birthstone', sub: 'For a birth month' }
  ];

  /* ---------- state ---------- */
  var S = { cats: [], picks: [], open: 0 };   // pick = {cat:'initial'|'birthstone', i:index}; kept for all 8 so a count change never loses choices
  var HOV = null;                              // {k, cat, i} while a tile is hovered (desktop)
  var q = function (s) { return root.querySelector(s); };
  var cardsEl = q('[data-vsn-cards]'), progEl = q('[data-vsn-progress]'), errEl = q('[data-vsn-err]');

  function finishValue() {
    var r = document.querySelector('fieldset[data-handle="finish"] input:checked');
    return r ? r.value : CFG.finish;
  }
  function fin() { return /silver/i.test(finishValue()) ? 'silver' : 'gold'; }
  function count() {
    var r = document.querySelector('fieldset[data-handle="number-of-pendants"] input:checked');
    var n = r ? parseInt(r.value, 10) : CFG.count;
    return n >= 1 && n <= MAX ? n : 2;
  }
  function firstEmpty() { var n = count(); for (var k = 0; k < n; k++) if (!S.picks[k]) return k; return -1; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function ord(k) { return ORDS[k].toLowerCase(); }

  /* ---------- picker thumbnails ---------- */
  function thumbHtml(cat, i, big) {
    var f = fin(), cls = 'vsn__thumb vsn__thumb--' + cat + (big ? ' is-big' : '');
    if (cat === 'initial') {
      return '<span class="vsn__glyph vsn__glyph--' + f + (big ? ' is-big' : '') + '" aria-hidden="true">' + LETTERS[i] + '</span>';
    }
    var ring = f === 'gold' ? 'linear-gradient(135deg,#fbe7a3 0%,#d9ac4b 45%,#b98a2e 70%,#f3d58a 100%)' : 'linear-gradient(135deg,#ffffff 0%,#c9cdd2 45%,#8f949a 70%,#e9ebee 100%)';
    return '<span class="' + cls + '"><i style="background-image:url(' + CFG.urls.stones + '),' + ring + ';background-size:1200% 100%,100% 100%;background-position:' + (i / 11 * 100) + '% 0,0 0"></i></span>';
  }
  function pickLabel(p) {
    return p.cat === 'initial' ? 'Initial: ' + LETTERS[p.i] : 'Birthstone: ' + STONES[p.i][1] + ' (' + STONES[p.i][0] + ')';
  }

  function drawCards() {
    var n = count();
    if (S.open >= n) S.open = firstEmpty();
    cardsEl.innerHTML = '';
    var fe = firstEmpty(), last = fe >= 0 ? fe : n - 1;
    for (var k = 0; k <= last; k++) {
      var p = S.picks[k], open = k === S.open, cat = S.cats[k];
      var card = el('div', 'vsn__card' + (open ? ' is-open' : '') + (p ? ' is-done' : ' is-empty'));
      card.setAttribute('data-card', k);
      var sub = p ? esc(pickLabel(p)) : (open ? '' : 'Not chosen yet');
      var cta = open ? (p ? 'Close' : '') : (p ? 'Change' : 'Choose');
      var head = el('button', 'vsn__card-head',
        '<span class="vsn__card-num">' + (k + 1) + '</span>' +
        '<span class="vsn__card-text"><span class="vsn__card-title">Pendant ' + (k + 1) + ' <small>of ' + n + '</small></span>' +
        (sub ? '<span class="vsn__card-sub">' + sub + '</span>' : '') + '</span>' +
        (p ? thumbHtml(p.cat, p.i, false) : '') +
        (cta ? '<span class="vsn__card-cta">' + cta + '</span>' : ''));
      head.type = 'button'; head.setAttribute('data-open', k); head.setAttribute('aria-expanded', open ? 'true' : 'false');
      card.appendChild(head);
      if (open) {
        var body = el('div', 'vsn__card-body');
        body.appendChild(el('p', 'vsn__q', 'What would you like on your ' + ord(k) + ' pendant?'));
        var ans = el('div', 'vsn__answers' + (cat ? ' is-compact' : ''));
        ANS.forEach(function (a) {
          var b = el('button', 'vsn__ans', thumbHtml(a.cat, a.cat === 'initial' ? 0 : 3, false) + '<span class="vsn__ans-text"><b>' + a.name + '</b><small>' + a.sub + '</small></span>');
          b.type = 'button'; b.setAttribute('data-cat', a.cat); b.setAttribute('data-card', k);
          b.setAttribute('aria-pressed', a.cat === cat ? 'true' : 'false');
          ans.appendChild(b);
        });
        body.appendChild(ans);
        if (cat) {
          body.appendChild(el('p', 'vsn__q2', 'Choose your ' + cat + (PREVIEW ? '<span class="vsn__hint"> &middot; hover to see it on your necklace</span>' : '')));
          var grid = el('div', 'vsn__grid vsn__grid--' + cat);
          var cnt = cat === 'initial' ? 26 : 12;
          for (var i = 0; i < cnt; i++) {
            var on = p && p.cat === cat && p.i === i;
            var lab = cat === 'initial' ? '' : '<span class="vsn__tile-lab"><b>' + esc(STONES[i][1]) + '</b><small>' + STONES[i][0] + '</small></span>';
            var t = el('button', 'vsn__tile vsn__tile--' + cat, thumbHtml(cat, i, true) + lab);
            t.type = 'button'; t.setAttribute('data-pick', i); t.setAttribute('data-pcat', cat); t.setAttribute('data-card', k);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
            t.setAttribute('aria-label', cat === 'initial' ? 'Initial ' + LETTERS[i] : STONES[i][1] + ', ' + STONES[i][0] + ' birthstone');
            grid.appendChild(t);
          }
          body.appendChild(grid);
        }
        card.appendChild(body);
      }
      cardsEl.appendChild(card);
    }
    var done = 0; for (k = 0; k < n; k++) if (S.picks[k]) done++;
    progEl.textContent = done === n ? 'All ' + n + ' chosen' : done + ' of ' + n + ' chosen';
  }

  /* ---------- line-item properties (same names and values the personalizer app sent) ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="finish"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    var box = form.querySelector('[data-vsn-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-vsn-props', ''); box.hidden = true; form.appendChild(box); }
    var rows = [], n = count();
    for (var k = 0; k < n; k++) {
      var p = S.picks[k]; if (!p) continue;
      rows.push([ORDS[k] + ' Pendant (Choose One)', p.cat === 'initial' ? 'Initial' : 'Birthstone']);
      rows.push(p.cat === 'initial' ? [ORDS[k] + ' Pendant: Initial', LETTERS[p.i]] : [ORDS[k] + ' Pendant: Birthstone', STONES[p.i][2]]);
    }
    rows.push(['_pplr_customization_id', '']);
    var sig = JSON.stringify(rows);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    box.innerHTML = '';
    rows.forEach(function (r) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'properties[' + r[0] + ']'; inp.value = r[1];
      box.appendChild(inp);
    });
  }

  /* ---------- preview ---------- */
  var imgs = {};
  function load(u) {
    if (!imgs[u]) imgs[u] = new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = function () { delete imgs[u]; rej(new Error(u)); }; im.src = u;
    });
    return imgs[u];
  }
  function rowUrl(view, f, slot) { return CFG.urls.rows[view][f][slot]; }
  /* the pendants to draw: [{slot, pick}] for the current count */
  function plan(picks, n) {
    var L = LAYOUT[n], out = [];
    for (var k = 0; k < n; k++) if (picks[k]) out.push({ slot: L.slots[k], pick: picks[k] });
    return out;
  }
  function paint(ctx, view, f, items, base, rows, stones) {
    var G = GEO[view];
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(base, 0, 0, 1080, 1080);
    items.forEach(function (it, j) {
      var s = G.slots[it.slot], idx = it.pick.cat === 'initial' ? it.pick.i : 26;
      ctx.drawImage(rows[j], idx * s.w, 0, s.w, s.h, s.x, s.y, s.w, s.h);
      if (it.pick.cat === 'birthstone') {
        var c = s.st;
        ctx.save();
        ctx.beginPath(); ctx.arc(c[0], c[1], c[2], 0, Math.PI * 2); ctx.clip();
        ctx.drawImage(stones, it.pick.i * 160, 0, 160, 160, c[0] - c[2], c[1] - c[2], c[2] * 2, c[2] * 2);
        ctx.lineWidth = view === 'close' ? 1.2 : 0.9; ctx.strokeStyle = f === 'gold' ? 'rgba(70,50,20,.42)' : 'rgba(60,60,64,.42)';
        ctx.beginPath(); ctx.arc(c[0], c[1], c[2] - 0.5, 0, Math.PI * 2); ctx.stroke();
        ctx.restore();
      }
    });
  }

  var cv = document.createElement('canvas'); cv.width = 1080; cv.height = 1080;
  cv.className = 'vsn-preview'; cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Preview of your Versana necklace');
  var token = 0;

  /* ---------- the design as its own slide in the photo gallery ----------
     The slide is built in the shopper's browser only. It is never saved as product media, so product feeds,
     catalogs and ads never see it. Shoppers can swipe to the photos and back to their design, and the
     thumbnail strip gets a "Your design" thumbnail at the top. */
  var gal = (function () {
    var slide = null, thumb = null, tctx = null;
    function sl() { var s = document.getElementById('Product-Slider'); return s && s.flkty && typeof s.reInit === 'function' ? s : null; }
    function strip() { return document.getElementById('Product-Thumbnails'); }
    function sfx(id) { return (id || '').replace(/^(Slide|Thumb)-/, ''); }
    function make() {
      slide = el('div', 'product-images__slide is-active vsn-slide');
      slide.id = 'Slide-vsn-design';
      var media = el('div', 'product-single__media vsn-slide__media');   // the theme expects this wrapper on every slide
      media.appendChild(cv);
      media.appendChild(el('span', 'vsn-slide__tag', 'Your design'));
      slide.appendChild(media);
      thumb = el('div', 'product-thumbnail is-active vsn-thumb');
      thumb.id = 'Thumb-vsn-design';
      var tc = document.createElement('canvas'); tc.width = tc.height = 200; tctx = tc.getContext('2d');
      thumb.appendChild(tc);
      thumb.appendChild(el('span', 'vsn-thumb__tag', 'Your design'));
    }
    function index() {
      var s = sl(); if (!s || !slide) return -1;
      for (var i = 0; i < s.flkty.cells.length; i++) if (s.flkty.cells[i].element === slide) return i;
      return -1;
    }
    /* slide N must match thumbnail N. After a finish change the theme puts that finish's photo in front of the
       other slides while its thumbnail stays last, so thumbnail clicks open the wrong photo; this checks for it. */
    function inOrder() {
      var s = sl(), st = strip(); if (!s || !st) return true;
      var th = st.querySelectorAll('.product-thumbnail.is-active'), cells = s.flkty.cells;
      if (th.length !== cells.length) return true;
      for (var i = 0; i < cells.length; i++) if (sfx(cells[i].element.id) !== sfx(th[i].id)) return false;
      return true;
    }
    /* rebuild the theme's slider with the slides in thumbnail order (our design first). The theme's thumbnail
       click handlers remember each photo's old position, so the thumbnails are swapped for clean copies first. */
    function rebuild() {
      var s = sl(); if (!s) return false;
      var st = strip(), holder = s.querySelector('.flickity-slider') || s;
      if (st) {
        var byId = {};
        Array.prototype.forEach.call(s.querySelectorAll('.product-images__slide'), function (e) { byId[sfx(e.id)] = e; });
        Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail'), function (t) { var e = byId[sfx(t.id)]; if (e) holder.appendChild(e); });
        Array.prototype.slice.call(st.querySelectorAll('.product-thumbnail')).forEach(function (t) {
          if (t !== thumb) t.parentNode.replaceChild(t.cloneNode(true), t);
        });
      }
      s.reInit();
      return true;
    }
    function add() {
      var s = sl(); if (!s) return false;
      if (!slide) make();
      var st = strip(); if (st) st.insertBefore(thumb, st.firstChild);
      var holder = s.querySelector('.flickity-slider') || s;
      holder.insertBefore(slide, holder.firstChild);
      return rebuild();
    }
    /* highlight the thumbnail of the slide on screen (the theme only does this when the slide changes) */
    function mark() {
      var s = sl(), st = strip(); if (!s || !st) return;
      var act = st.querySelectorAll('.product-thumbnail.is-active');
      Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail.is-initial-selected'), function (t) { t.classList.remove('is-initial-selected'); });
      if (act[s.flkty.selectedIndex]) act[s.flkty.selectedIndex].classList.add('is-initial-selected');
    }
    return {
      present: function () { return index() >= 0; },
      /* put the slide in the gallery (if it isn't already) and bring it into view */
      show: function (select) {
        if (index() < 0) { if (!add()) return false; }
        else if (!inOrder()) rebuild();
        tctx.clearRect(0, 0, 200, 200); tctx.drawImage(cv, 60, 130, 840, 840, 0, 0, 200, 200);   // the side of the chain with the pendants
        var s = sl(), i = index();
        if (select !== false && i >= 0 && s.flkty.selectedIndex !== i) s.flkty.select(i, false, true);
        mark();
        return true;
      },
      /* nothing chosen (e.g. a hover ended before the first pick): the gallery goes back to the photos only */
      hide: function () {
        if (!slide || !slide.parentNode) return;
        slide.parentNode.removeChild(slide);
        if (thumb.parentNode) thumb.parentNode.removeChild(thumb);
        rebuild(); mark();
      },
      /* after a finish change: put the slides back in thumbnail order, keeping the photo the theme chose */
      tidy: function () {
        if (inOrder()) return;
        var s = sl(), keep = s && s.flkty.selectedElement;
        rebuild();
        s = sl(); if (s && keep) { var i = s.flkty.cells.map(function (c) { return c.element; }).indexOf(keep); if (i >= 0) s.flkty.select(i, false, true); }
        mark();
      },
      box: function () { var s = sl() || document.getElementById('Product-Slider'); return s ? s.getBoundingClientRect() : null; }
    };
  })();

  function effective() {
    var picks = S.picks.slice();
    if (HOV) picks[HOV.k] = { cat: HOV.cat, i: HOV.i };
    return picks;
  }
  function anyPick() { var n = count(); for (var k = 0; k < n; k++) if (S.picks[k]) return true; return false; }
  var retries = 0;
  function render() {
    if (!PREVIEW) return;
    var picks = effective(), n = count(), items = plan(picks, n);
    if (!items.length) { token++; gal.hide(); gal.tidy(); return; }
    var t = ++token, f = fin(), view = LAYOUT[n].view;
    var need = [load(CFG.urls.base[view][f]), load(CFG.urls.stones)];
    items.forEach(function (it) { need.push(load(rowUrl(view, f, it.slot))); });
    Promise.all(need).then(function (im) {
      if (t !== token) return;
      paint(cv.getContext('2d'), view, f, items, im[0], im.slice(2), im[1]);
      if (!gal.show() && retries++ < 20) setTimeout(render, 250);   // the theme's gallery isn't ready yet
    })['catch'](function (e) { if (window.console) console.warn('[versana] preview', e); });
  }
  /* fetch what the current count and metal will need, so the first pick and hovering feel instant */
  function warm() {
    if (!PREVIEW) return;
    var f = fin(), n = count(), L = LAYOUT[n];
    [CFG.urls.base[L.view][f], CFG.urls.stones].concat(L.slots.map(function (s) { return rowUrl(L.view, f, s); }))
      .forEach(function (u) { load(u)['catch'](function () {}); });
  }
  /* ---------- scrolling ---------- */
  function hh() { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0; }
  function scrollToCard(k) {
    var c = cardsEl.querySelector('[data-card="' + k + '"]'); if (!c) return;
    var t = c.getBoundingClientRect().top, vh = window.innerHeight || document.documentElement.clientHeight;
    if (t < hh() + 10 || t > vh * 0.7) window.scrollTo({ top: Math.max(0, t + window.pageYOffset - hh() - 16), behavior: 'smooth' });
  }
  /* once every pendant is chosen, glide up to the finished necklace (skipped when it is already on screen, e.g. the sticky desktop gallery) */
  function showPreview() {
    var r = gal.box(); if (!r) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.height && (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height >= 0.6) return;
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - hh() - 10), behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  function refresh() { drawCards(); syncProps(); errEl.hidden = true; }
  cardsEl.addEventListener('click', function (e) {
    var t = e.target;
    var pick = t.closest('button[data-pick]');
    if (pick) {
      var k = +pick.getAttribute('data-card');
      S.picks[k] = { cat: pick.getAttribute('data-pcat'), i: +pick.getAttribute('data-pick') };
      S.cats[k] = S.picks[k].cat; HOV = null;
      var fe = firstEmpty(); S.open = fe;
      refresh(); render();
      if (fe >= 0) scrollToCard(fe); else if (PREVIEW) setTimeout(showPreview, 60);
      return;
    }
    var ans = t.closest('button[data-cat]');
    if (ans) { HOV = null; S.cats[+ans.getAttribute('data-card')] = ans.getAttribute('data-cat'); drawCards(); render(); return; }
    var head = t.closest('button[data-open]');
    if (head) {
      var j = +head.getAttribute('data-open'); S.open = S.open === j ? -1 : j;
      if (S.open >= 0 && !S.cats[j] && S.picks[j]) S.cats[j] = S.picks[j].cat;
      if (HOV) { HOV = null; render(); }
      drawCards();
    }
  });
  /* desktop: hovering an option shows it on the necklace in that pendant's spot */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches, hovT;
  if (canHover) {
    cardsEl.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('button[data-pick]');
      var next = b ? { k: +b.getAttribute('data-card'), cat: b.getAttribute('data-pcat'), i: +b.getAttribute('data-pick') } : null;
      if (!next && !HOV) return;
      if (next && HOV && next.k === HOV.k && next.cat === HOV.cat && next.i === HOV.i) return;
      clearTimeout(hovT);
      hovT = setTimeout(function () { HOV = next; render(); }, next ? 40 : 140);
    });
    cardsEl.addEventListener('mouseleave', function () { clearTimeout(hovT); if (HOV) { HOV = null; render(); } });
  }
  /* ---------- pendant count: a dropdown with prices (like Eliora) that drives the theme's hidden "Number of Pendants" buttons ---------- */
  var countSel = q('[data-vsn-count]');
  function counts() {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll('fieldset[data-handle="number-of-pendants"] input'), function (r) {
      var n = parseInt(r.value, 10); if (n >= 1 && n <= MAX && out.indexOf(n) < 0) out.push(n);
    });
    if (!out.length) Object.keys(CFG.prices || {}).forEach(function (k) { var n = parseInt(k.split('|')[1], 10); if (n && out.indexOf(n) < 0) out.push(n); });
    return out.sort(function (a, b) { return a - b; });
  }
  function drawCount() {
    if (!countSel) return;
    var f = finishValue(), n = count();
    countSel.innerHTML = '';
    counts().forEach(function (c) {
      var o = document.createElement('option'), p = CFG.prices && CFG.prices[f + '|' + c];
      o.value = c; o.textContent = c + (c === 1 ? ' pendant' : ' pendants') + (p ? '  —  ' + p : '');
      if (c === n) o.selected = true;
      countSel.appendChild(o);
    });
  }
  if (countSel) countSel.addEventListener('change', function () {
    var r = document.querySelector('fieldset[data-handle="number-of-pendants"] input[value="' + countSel.value + '"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.dispatchEvent(new Event('input', { bubbles: true })); }
  });

  /* finish or pendant-count change: the theme switches the variant; redraw the design and the cards */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('fieldset[data-handle="finish"] input')) {
      drawCount(); drawCards(); warm(); setTimeout(render, 60);
    } else if (t.matches('fieldset[data-handle="number-of-pendants"] input')) {
      var fe = firstEmpty();
      if (S.open < 0 || S.open >= count()) S.open = fe;
      errEl.hidden = true;
      if (countSel && countSel.value !== String(count())) countSel.value = String(count());
      drawCards(); syncProps(); warm(); setTimeout(render, 60);
    }
  });

  /* every pendant is required before Add to bag / Buy it now */
  function guard(e) {
    var form = productForm(); if (!form) return;
    var fe = firstEmpty(); if (fe < 0) { syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var btn = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"]');
      if (!btn) return;
      if (!form.contains(btn) && btn.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    var n = count(), left = 0; for (var k = 0; k < n; k++) if (!S.picks[k]) left++;
    errEl.textContent = left === n ? 'Choose what goes on your first pendant to continue.'
      : 'Choose what goes on your ' + ord(fe) + ' pendant to finish your ' + ITEM + (left > 1 ? ' (' + left + ' left).' : '.');
    errEl.hidden = false;
    S.open = fe; drawCards(); scrollToCard(fe);
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme rebuilds parts of the product area on variant change; keep our inputs and the design slide in place */
  var moT;
  new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () { syncProps(); if (PREVIEW && anyPick() && !gal.present()) gal.show(false); }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  drawCount(); drawCards(); syncProps();
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
})();
